var helpers = require('../helpers/helpers');

var sparqlQuery = require('./sparql_query'); // Fiter-out properties. Can't be filtered by
// `?subject a wikibase:Item`, as those triples are omitted
// https://www.mediawiki.org/wiki/Wikibase/Indexing/RDF_Dump_Format#WDQS_data_differences


var itemsOnly = 'FILTER NOT EXISTS { ?subject rdf:type wikibase:Property . } ';

module.exports = function (property, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var limit = options.limit,
      caseInsensitive = options.caseInsensitive,
      keepProperties = options.keepProperties;
  var valueFn = caseInsensitive ? caseInsensitiveValueQuery : directValueQuery;
  var filter = keepProperties ? '' : itemsOnly; // Allow to request values for several properties at once

  if (property instanceof Array) {
    property = property.map(prefixifyProperty).join('|');
  } else {
    property = prefixifyProperty(property);
  }

  var valueBlock = getValueBlock(value, valueFn, property, filter);
  var sparql = "SELECT DISTINCT ?subject WHERE { ".concat(valueBlock, " }");
  if (limit) sparql += " LIMIT ".concat(limit);
  return sparqlQuery(sparql);
};

function getValueBlock(value, valueFn, property, filter) {
  if (!(value instanceof Array)) {
    return valueFn(property, getValueString(value), filter);
  }

  var valuesBlocks = value.map(getValueString).map(function (valStr) {
    return valueFn(property, valStr, filter);
  });
  return '{ ' + valuesBlocks.join('} UNION {') + ' }';
}

function getValueString(value) {
  if (helpers.isItemId(value)) {
    value = "wd:".concat(value);
  } else if (typeof value === 'string') {
    value = "'".concat(value, "'");
  }

  return value;
}

function directValueQuery(property, value, filter, limit) {
  return "?subject ".concat(property, " ").concat(value, " .\n    ").concat(filter);
} // Discussion on how to make this query optimal:
// http://stackoverflow.com/q/43073266/3324977


function caseInsensitiveValueQuery(property, value, filter, limit) {
  return "?subject ".concat(property, " ?value .\n    FILTER (lcase(?value) = ").concat(value.toLowerCase(), ")\n    ").concat(filter);
}

var prefixifyProperty = function prefixifyProperty(property) {
  return 'wdt:' + property;
};